import { Vue, Component, Prop } from "vue-property-decorator";
import { User } from "@/components/User";
import { SDS } from "@/components/SDS";
import Map from "@/components/map/Map";
import { IMap, IMapViewExtent, IFeatureInfo, IInfoSchema, 
         ICodeList, IMapViewInfo, 
         IMapFilter, IMapLayer } from "@/components/map/types";
import { IDialog } from "@/components/shared/types";
import { getConsonant, isMobile, isArray, isObject, isEmptyObject, isFunction } from "@/common/utils";
import { APP_URL } from "@/common/http";

const MEASURER_STORE = {
    lists: [{
      name: 'distance',
      icon: 'straighten'
    },{
      name: 'area2',
      icon: 'flip_to_front'
    },{
      name: 'coordinate',
      icon: 'location_on'
    }],
    units: ['metric', 'thai'],
    crss: ['WGS84', 'UTM']
  };

@Component
export default class AppBase extends Vue {
  appUrl = APP_URL;
  sds:SDS = new SDS(); // user for sds service

  // the subclass has onResize() listener that will update WindowWidth and TocWidth
  TocWidth: number = 330;
  //WindowWidth: number = window.innerWidth;
  mapFilter: IMapFilter = {
    Source: "GISagro",
    Keyword: null,
    ProvinceCode: null,
    AmphoeCode: null,
    TambonCode: null,
    CropType: null,
    CropGenus: null,
    CropSpecies: null,
    CropText: null,
    DeedType: null,
    GrowOrHarvest: null,
    GrowOrHarvestYear: null,
    AreaType: null,
    Area1: {
      Rai: null,
      Ngan: null,
      SqWah: null
    },
    Area2: {
      Rai: null,
      Ngan: null,
      SqWah: null
    }
  };
  mapLayers?: IMapLayer[] = [];
  
  mapLayerStore: IMapLayer[] = null;
  // auto order map layer z-index with Point on top, Line in the middle and Polygon at the bottom
  mapLayersPoint: IMapLayer[] = [];
  mapLayersLine: IMapLayer[] = [];
  mapLayersPolygon: IMapLayer[] = [];

  $map: Map = null; // passed from onMapCreated
  /*map: IMap = {
    Action: {
      name: 'getInfo'
    }
  };*/
  BaseMapListIsOpen: boolean = false;

  zoom: number = 0; 
  mapExtent:[number,number,number,number] = [95.854, 5.299, 106.064, 20.533];
  activeBaseMap: string = 'osm.mapnik'; //'google.road'; //'gistda.thaichote';
  activeAction: string = null; //'getInfo';
  
  //map info
  featureInfo: IFeatureInfo = {};
  mapInfo: IInfoSchema = {
    title: 'featureInfo',
    items: []
  };
  showMapInfoTab: number = 0;

  get mapInfoExistsInDb() : boolean {
    let f = this.mapInfo && this.mapInfo.feature;
    return f && (f.getId() || f.get('gid'));
  }

  PageView: number = 0;
  async fetchPageView(page:string) {
    try {
      let data = await this.User.requestResource('mis/pageview/' + page);
      this.PageView = data[0].counter + 1;
      data = await this.User.requestResource('mis/pageview', 'PUT', {
        page: page,
        counter: 1
      });
      let d = data;
    } catch (error) {
      console.log(error);
    }
  }

  get Counter() : string[] {
    return [('0000000' + this.PageView).slice(-7)];
  };
  
  showMeasurer: boolean = false;
  showMeasurerAt: string = null; // null | center | bottom-center ...
  // measurer v-window is initially hidden. 
  // its clientWidth/Height is not set even it is loaded
  // so we use located-at prop to reposition it for 
  // the first time to show up it
  measurerStore: {[key:string] : any} = MEASURER_STORE;
  measurerIndex: number = 0;
  measurer: {[key:string] : any} = MEASURER_STORE.lists[0];
  measureUnit: string = 'metric';
  measureCrs: string = 'WGS84';

  onMeasurerVisible(vWindow) {
    //this.$map.setMapAction('measure', action.params || {});
  }

  get activeMeasurer() {
    return {
      name: this.measurer.name,
      icon: this.measurer.icon,
      unit: this.measureUnit,
      crs: this.measureCrs
    }
  };

  changeMeasurer(measurer) {
    this.measurer = measurer;
    this.$map.setMapAction('measure', {
      name: this.measurer.name,
      icon: this.measurer.icon,
      unit: this.measureUnit,
      crs: this.measureCrs
    });
  };

  changeMeasurerUnit(unit) {
    this.measureUnit = unit;
    this.$map.setMapAction('measure', {
      name: this.measurer.name,
      icon: this.measurer.icon,
      unit: this.measureUnit,
      crs: this.measureCrs
    });
  };

  changeMeasurerCrs(crs) {
    this.measureCrs = crs;
    this.$map.setMapAction('measure', {
      name: this.measurer.name,
      icon: this.measurer.icon,
      unit: this.measureUnit,
      crs: this.measureCrs
    });
  };

  getMeasureUnitName(unit) {
    // return unitMetirc | unitThai
    return 'unit' + unit.toLowerCase()
                    .replace(/(?:^|\s)\S/g, function(a) {
                      return a.toUpperCase();
                    });
  };

  locator: string = 'WGS84';
  showLocator: boolean = false;
  showLocatorAt: string = null;
  latitude: number = 13.8;
  longitude: number = 100.8;
  locatorX: number = 694578.889;
  locatorY: number = 1526336.719;
  locatorZone: number = 47;
  locatorNS: "N" | "S" = 'N';

  resetLocationForm(form) {
    (<any>this.$refs[form]).reset()
  };

  searchLocation(crs) {
    let location;
    if (crs=='WGS84') {
      this.longitude = parseFloat(this.longitude + '');
      this.latitude = parseFloat(this.latitude + '');
      location = [this.longitude,this.latitude];
    } else {
      this.locatorX = parseFloat(this.locatorX + '');
      this.locatorY = parseFloat(this.locatorY + '');
      this.locatorZone = parseFloat(this.locatorZone + '');
      location = this.$map.utmToLatLon(
        this.locatorX, this.locatorY, this.locatorZone, this.locatorNS
      );
    }
    this.$map.gotoLocation(location);
  };

  get supportGeolocation() : boolean {
    return !!(APP_URL.match(/^https:\/\//i) && navigator.geolocation);
  }

  locatingMyLocation:boolean = false;
  gotoMyLocation() {
    if (this.supportGeolocation) {
      this.locatingMyLocation = true;
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.$map.gotoLocation([position.coords.longitude,position.coords.latitude]);
          this.locatingMyLocation = false;
        },
        (error) => {
          this.locatingMyLocation = false;
          this.alertError(error.message);
        }, {
          enableHighAccuracy: true
          , timeout: 5000
        }
      );
    }
  };

  closeLocator() {
    this.showLocator = !this.showLocator;
    this.$map.clearLocator();
  };
  
  srhProvinces: ICodeList[] = [];
  srhAmphoes: ICodeList[] = [];
  srhTambons: ICodeList[] = [];
  //srhSelectedProvince = null;
  //srhSelectedAmphoe = null;
  //srhSelectedTambon = null;

  isLoadingProvinces: boolean = false;
  isLoadingAmphoes: boolean = false;
  isLoadingTambons: boolean = false;

  get isMobile() : boolean {
    return isMobile();
  };

  get WindowWidth() : number {
    return this.$store.getters.WindowWidth;
  }

  set WindowWidth(value:number) {
    this.$store.commit('notifyChange', {
      WindowWidth: value
    });
  }

  get isSmallOrMobile() : boolean {
    return this.isMobile || this.WindowWidth<576;
  }

  get HelperWidth() : number {
    return Math.min(this.WindowWidth, 760);
  }

  get language() : string {
    return this.User.Language;
  };

  set language(value) {
    this.$store.commit('notifyChange', {
      User: {
        Settings: {
          Language: value
        }
      }
    });
  };
  
  get User() : User {
    return this.$store.getters.User;
  };

  set User(user:User) {
    this.$store.commit('notifyChange', {
      User: user // .Properties,
    });
  };

  get ImAdmin() : boolean {
    return this.User.isSuperAdmins || this.User.isAdmins;
  };

  get ICanEdit() : boolean {
    return this.User.canEdit;
  }

  /**
   * Alert Dialog
   */
  get Dialog() : IDialog {
    return this.$store.getters.Dialog;
  }
  
  get mapLayersOrdered() : IMapLayer[] {
    return this.mapLayersPoint.concat(this.mapLayersLine).concat(this.mapLayersPolygon);
  };

  get mapLayersReversed() : IMapLayer[] {
    let layers = [];
    this.mapLayersPoint.map((ml) => {
      layers.unshift(ml);
    });
    this.mapLayersLine.map((ml) => {
      layers.unshift(ml);
    });
    this.mapLayersPolygon.map((ml) => {
      layers.unshift(ml);
    });
    return layers;
  };

  hasChildSource(layer:IMapLayer) : boolean {
    let children = ['children','legend'];
    let i, j, has = false;
    for (i=0; i<children.length && !has; i++) {
      has = layer[children[i]] && layer[children[i]].length>0;
      if (has) {
        for (j=0; j<layer[children[i]].length; j++) {
          has = has && layer[children[i]][j].mapSources && layer[children[i]][j].mapSources.length>0;
          if (has) {
            break;
          }
        }
      }    
    }
    return has;
  }
  
  showMapLayer(layer:IMapLayer) {
    if (layer.type) {
      layer.checked = (layer.checked===true);
      // todo: add this layer to map
      // add it to legend (mapLayersPoint || mapLayersLine || mapLayersPolygon)
    }
    if (layer.mapSources && (layer.mapSources.length>0 || this.hasChildSource(layer))) {
      let addThisLayer:IMapLayer = null;
      let parentMapSources = null; //layer.parent ? layer.parent.mapSources : null;
      let parent = layer.parent;
      while (parent && !parentMapSources) {
        parentMapSources = layer.parent.mapSources;
        parent = parent.parent;
      }
      layer.visible = (layer.visible===true);
      layer.mapSources.forEach((ms,index) => {
        ms.visible = (layer.visible===true);
        if (parentMapSources) {
          // a child mapSource should exist in its parent mapSources
          let i, exists:boolean = false;
          for (i=0; i<parentMapSources.length && !exists; i++) {
            let ps = parentMapSources[i];
            exists = ms.service==ps.service && ms.url==ps.url;
            if (!!ms.service.match(/WMS/i)) {
              exists = exists && (ms.params.LAYERS==ps.params.LAYERS);
            } else if (!!ms.service.match(/WFS|WMTS/i)) {
              exists = exists && (ms.featureType==ps.featureType);
            }
            if (exists && !(layer.type=='radio' ||ms.params2)) {
              //ms = ps;
              layer.mapSources[index] = ps;
            }
          };
          if (!exists) {
            // added to parent.mapSources
            parentMapSources.push(ms);
          }
          //if (layer.type=='radio') {
          //  parentMapSources = null; //need to add layer with radio control to the list
          //}
        }
      });
      if (!parentMapSources) {
        this.addLayerToMap(layer);
      }
    }
    // defined actions event listener
    // when layer.type is defined and when click the check icon,
    // the action is 'changeChecked'
    if (layer.type || layer.mapSources || layer.actions) {
      layer.doAction = this.doMapLayerAction;
    }
    let children = layer.children || layer.legend;
    if (children) {
      let checked:boolean | "indeterminate" = false;
      let visible:boolean = false;
      children.forEach((child) => {
        child.parent = layer;
        if (layer.type && child.type && child.checked!=checked) {
          layer.checked = 'indeterminate';
        }
        if (child.mapSources && child.mapSources.length>0) {
          child.mapSources.forEach((ms) => {
            if (!ms) {
              let c = child;
              let cs = children;
              //debugger
            }
            if (ms.visible!==false) {
              layer.visible = ms.visible;
              return;
            }
          });
        }
        this.showMapLayer(child);
      }, this);
    }
  };

  addLayerToMap(layer:IMapLayer) {
    if (layer.geomType=='Point') {
      this.mapLayersPoint.push(layer);
    } else if (layer.geomType=='Line') {
      this.mapLayersLine.push(layer);
    } else {
      this.mapLayersPolygon.push(layer);
    }
  };

  VisibleLayers: IMapLayer[] = [];
  setVisibleLayers() {
    let vls:IMapLayer[] = [];
    if (this.$map && this.$map.map) {
      let mapLayers = this.mapLayersOrdered;
      if (!(mapLayers && mapLayers.length>0)) {
        mapLayers = this.$map.map.MapLayers;
      }
      mapLayers.forEach((ml) => {
        let group:IMapLayer = null;
        if (ml.mapSources && ml.mapSources.length>0) {
          if (ml.type=='checkbox' && ml.checked || (!ml.type && ml.visible)) {
            if (!ml.parent || (ml.parent && !ml.parent.parent)) {
              vls.push(ml);
            } else if (ml.parent && !!ml.parent.title) {
              for (let i=0; i<vls.length && !group; i++) {
                if (!vls[i].type && vls[i].header==ml.parent.title) {
                  group = vls[i];
                }
              }
              if (!group) {
                group = {
                  header: ml.parent.title,
                  children: []
                };
                if (ml.parent.actions) {
                  group.actions = ml.parent.actions;
                  group.doAction = this.doMapLayerAction;
                }
                vls.push(group);
              }
              //clone ml to new group
              group.children.push(ml);
            }
          } else {
            let sibling = [];
            let startAt = 0;
            if (ml.type=='radio' && ml.parent && ml.parent.children) {
              sibling = ml.parent.children;
              startAt = sibling.indexOf(ml);
              group = {
                header: ml.parent.title
              }
            } else if (!ml.type && ml.children) {
              sibling = ml.children;
              group = {
                header: ml.title
              }
            }
            let i, checked = false;
            for (i=startAt; i<sibling.length; i++) {
              if (sibling[i].checked) {
                //group.style = {
                //  display: 'none'
                //};
                group.children = [sibling[i]];
                vls.push(group);
                break;
              }
            }
          }
        }
      });
    }
    this.VisibleLayers = vls;
  }

  cloneMapLayers(obj, showCtrls?:boolean) {
    showCtrls = !!showCtrls;
    let o:any = {};
    let exclude = '^mapLayers$|^nativeLayer$|^doAction$|^parent$|^events$|^SOFTOO_MAPS$';
    if (!showCtrls) {
      exclude += '|^type$|^checked$|^radioGroup$';
    }
    let regex = new RegExp(exclude,'i');
    for (let p in obj) {
      if (!(isFunction(obj[p]) || p.match(regex))) {
        if (isArray(obj[p])) {
          o[p] = obj[p].map((a) => {
            if (isObject(a)) {
              return this.cloneMapLayers(a, showCtrls);
            } else {
              return a;
            }
          });
        } else if (isObject(obj[p])) {
          o[p] = this.cloneMapLayers(obj[p], showCtrls);
        } else if (obj.hasOwnProperty(p)) {
          o[p] = obj[p];
        }
      } else if (p=='nativeLayer' && obj.service && obj.service.match(/^Vector$/i)) {
        let source = obj[p].getSource();
        if (source.source) { //this is a cluster source
          source = source.source;
        }
        let features = source.getFeatures();
        if (features && features.length>0) {
          o.geoJSONs = features.map((f) => {
            let gj = this.$map.FeatureToGeoJSON(f);
            delete gj.featureOnMap;
            return gj;
          });
        }
      }
    }
    if (o.mapSources || o.actions) {
      o.showCtrls = showCtrls;
    }
    return o;
  }

  showMapForPrint(type:"map" | "land" | "ecoplant" | "rice") {
    let url = window.location.protocol + '//' + 
              window.location.hostname + 
              (window.location.port ? ':' + window.location.port : '') +
              '/print' + type;
    let ext:IMapViewExtent = this.$map.getViewExtent();
    let vinfo:IMapViewInfo = this.$map.getViewInfo();
    this.setVisibleLayers();
    let mapLayers = this.VisibleLayers.map((vl) => {
      return this.cloneMapLayers(vl,false);
    });
    this.$store.commit('notifyChange', {
      Storage: {
        language: this.language,
        uid: this.User.HalloId,
        userOrgc: this.User.Organization ? this.User.Organization.Code : null,
        token: this.User.Token,
        mapExtent: ext.wgs84,
        mapCenter: vinfo.paddingCenter.wgs84,
        mapZoom: vinfo.zoom,
        //aoiId: aoiId,
        basemap: this.activeBaseMap,
        mapLayers: mapLayers,
        mapFilter: this.mapFilter
      }
    });
    let win = window.open(url, 'gisagroprint');
    win.focus();
  }

  //will be override in gisagro.map.class.ts
  doMapLayerAction(data) {
  }

  showDialog(title:string, message:string | string[], type?:string) {
    this.$store.commit('notifyChange', {
      Dialog: {
        Type: type || 'info',
        Title: title,
        Message: message || null,
        OkText: null,
        CancelText: 'close',
        show: true,
        OnClose: null
      }
    });
  };
  
  alertError(error:string | string[]) {
    this.$store.commit('notifyChange', {
      Dialog: {
        Type: 'error',
        Title: 'error',
        Message: error || null,
        OkText: null,
        CancelText: 'close',
        show: true,
        OnClose: null
      }
    });
  };

  showWait(title:string, error?:string | string[]) {
    this.$store.commit('notifyChange', {
      Dialog: {
        Type: error ? 'error' : 'info',
        Title: title,
        Message: error || null,
        OkText: null,
        CancelText: 'close',
        wait: !error,
        show: true,
        OnClose: null
      }
    });
  };

  closeDialog(result:"ok" | "cancel" | "close") {
    let OnClose = this.Dialog.OnClose;
    let close = true;
    if (OnClose) {
      close = OnClose(result);
    }
    if (close!==false) {
      this.$store.commit('notifyChange', {
        Dialog: {
          Message: null,
          show: false,
          wait: false
        }
      });
    }
  };

  getProvinceNameByName(name:string,lang:"th" | "en") : string {
    let theName = '';
    if (!name || name.match(/00|01/) || 
        !(this.srhProvinces && this.srhProvinces.length)) {
        theName = name;
    }
    let lower = name.toLowerCase();
    let consonant = getConsonant(lower);
    if (consonant=='smtprkrn') {
      consonant = 'smtprkn'; // Samut Prakarn --> Samut Prakan
    }
    this.srhProvinces.forEach((p) => {
      let name = lang=='th' ? p.name : p.name_en;
      name = name.toLowerCase();
      if (name==lower || getConsonant(name)==consonant) {
        theName = p.name; // this.language=='th' ? p.name : p.name_en;
        return;
      }
    });
    return theName || name + " NO MAPPING";
  };

  getProvinceNameByCode(code:string) : string {
    let theName = '';
    if (!code || code.match(/^00$|^0$|^01$|^1$/) || 
        !(this.srhProvinces && this.srhProvinces.length)) {
        theName = code;
    }
    this.srhProvinces.forEach((p) => {
      if (p.code==code) {
        theName = p.name; // this.language=='th' ? p.name : p.name_en;
        return;
      }
    });
    return theName;
  };

  onProvinceChange() {
    this.zoomToProvince();
    this.fetchAmphoes();
  };

  onAmphoeChange() {
    this.zoomToAmphoe();
    this.fetchTambons();
  };
  
  onTambonChange() {
    this.zoomToTambon();
  };
  
  async fetchProvinces() {
    try {
      this.isLoadingProvinces = true;
      let data = await this.User.requestResource('codelist/province');
      this.srhProvinces = data.map((d) => {
        return d;
      });
      this.isLoadingProvinces = false;
    } catch (error) {
      this.isLoadingProvinces = false;
    }
  };

  async fetchAmphoes() {
    try {
      this.srhAmphoes = [];
      this.srhTambons = [];
      if (!this.mapFilter.ProvinceCode) {
        this.mapFilter.TambonCode = null;
        this.mapFilter.AmphoeCode = null;
      } else {
        this.isLoadingAmphoes = true;
        let rest = 'codelist/amphoe/' + this.mapFilter.ProvinceCode;
        let data = await this.User.requestResource(rest);
        this.srhAmphoes = data.map((d) => {
          return d;
        });
        this.isLoadingAmphoes = false;
      }
    } catch (error) {
      this.isLoadingAmphoes = false;
    }
  };

  async fetchTambons() {
    try {
      this.srhTambons = [];
      if (!this.mapFilter.AmphoeCode) {
        this.mapFilter.TambonCode = null;
      } else {
        this.isLoadingTambons = true;
        let rest = 'codelist/tambon/' + this.mapFilter.AmphoeCode;
        let data = await this.User.requestResource(rest);
        this.srhTambons = data.map((d) => {
          return d;
        });
        this.isLoadingTambons = false;
      }
    } catch (error) {
      this.isLoadingTambons = false;
    }
  };

  async zoomToProvince(resetMapExtent?:boolean) {
    try {
      if (!this.mapFilter.ProvinceCode) {
        this.$map.clearAoi();
        this.$map.clearFilter();
        this.$map.MapExtent = this.mapExtent;
      } else {
        let province:ICodeList;
        this.srhProvinces.forEach((p) => {
          if (p.code==this.mapFilter.ProvinceCode) {
            province = p;
            return;
          }
        });
        this.setFilter();
        if (!province.feature) {
          let url = 'gis/province/' + this.mapFilter.ProvinceCode + '?crs=3857';
          province.feature = await this.User.requestResource(url);
          province.feature = this.$map.GeoJSONToFeatures(province.feature);
        }
        this.$map.addFeaturesToLayer(province.feature, "AoiLayer");
        if (resetMapExtent) {
          this.mapExtent = this.$map.MapExtent;
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  async zoomToAmphoe(resetMapExtent?:boolean) {
    try {
      if (!this.mapFilter.AmphoeCode) {
        this.zoomToProvince();
      } else {
        let amphoe:ICodeList = {
          code: null,
          name: null
        };
        this.srhAmphoes.forEach((a) => {
          if (a.code==this.mapFilter.AmphoeCode) {
            amphoe = a;
            return;
          }
        });
        this.setFilter();
        if (!amphoe.feature) {
          let url = 'gis/amphoe/' + this.mapFilter.AmphoeCode + '?crs=3857';
          amphoe.feature = await this.User.requestResource(url);
          amphoe.feature = this.$map.GeoJSONToFeatures(amphoe.feature);
        }
        this.$map.addFeaturesToLayer(amphoe.feature, "AoiLayer");
        if (resetMapExtent) {
          this.mapExtent = this.$map.MapExtent;
        }
      }
    } catch (error) {
    }
  };

  async zoomToTambon(resetMapExtent?:boolean) {
    try {
      if (!this.mapFilter.TambonCode) {
        this.zoomToAmphoe();
      } else {
        let tambon:ICodeList = {
          code: null,
          name: null
        };
        this.srhTambons.forEach((t) => {
          if (t.code==this.mapFilter.TambonCode) {
            tambon = t;
            return;
          }
        });
        this.setFilter();
        if (!tambon.feature) {
          let rsc = 'gis/tambon/' + this.mapFilter.TambonCode + '?crs=3857';
          tambon.feature = await this.User.requestResource(rsc);
          tambon.feature = this.$map.GeoJSONToFeatures(tambon.feature);
        }
        this.$map.addFeaturesToLayer(tambon.feature, "AoiLayer");
        if (resetMapExtent) {
          this.mapExtent = this.$map.MapExtent;
        }
      }
    } catch (error) {
    }
  }

  setFilter() {
    let filter:any = {};
    if (this.mapFilter.Source=='GISagro' && this.mapFilter.TambonCode) {
      filter.aag = 'aag5_fk=' + this.mapFilter.TambonCode;
    } else if (this.mapFilter.AmphoeCode) {
      filter.aag = 'aag4_fk=' + this.mapFilter.AmphoeCode;
    } else if (this.mapFilter.ProvinceCode) {
      filter.aag = 'aag3_fk=' + this.mapFilter.ProvinceCode;
    }
    if (this.mapFilter.Source=='GISagro') {
      if (this.mapFilter.CropSpecies) {
        filter.crop = 'crop_fk=' + this.mapFilter.CropSpecies;
      } else if (this.mapFilter.CropGenus) {
        filter.crop = 'genus_fk=' + this.mapFilter.CropGenus;
      } else if (this.mapFilter.CropType) {
        filter.crop = 'type_fk=' + this.mapFilter.CropType;
      }
      if (this.mapFilter.DeedType) {
        filter.deed = "deed_type='" + this.mapFilter.DeedType + "'";
      }
      if (this.mapFilter.GrowOrHarvest && this.mapFilter.GrowOrHarvestYear) {
        let year = this.mapFilter.GrowOrHarvestYear;
        if (year>2500) year -= 543;
        filter.year = this.mapFilter.GrowOrHarvest + '_yyyy=' + year;
      }
      if (this.mapFilter.AreaType=='lte' || this.mapFilter.AreaType=='gte') {
        if (!!this.mapFilter.Area1.Rai || this.mapFilter.Area1.Rai===0 ||
            !!this.mapFilter.Area1.Ngan || this.mapFilter.Area1.Ngan===0 ||
            !!this.mapFilter.Area1.SqWah || this.mapFilter.Area1.SqWah===0)  {
          let sqm = (this.mapFilter.Area1.Rai || 0) * 1600 +
                    (this.mapFilter.Area1.Ngan || 0) * 400 +
                    (this.mapFilter.Area1.SqWah || 0) * 4;
          filter.area = 'area_sqm' + (this.mapFilter.AreaType=='lte' ? '<=' : '>=') + sqm;
        }
      } else if (this.mapFilter.AreaType=='between' && 
        (!!this.mapFilter.Area1.Rai || this.mapFilter.Area1.Rai===0 ||
          !!this.mapFilter.Area1.Ngan || this.mapFilter.Area1.Ngan===0 ||
          !!this.mapFilter.Area1.SqWah || this.mapFilter.Area1.SqWah===0) && 
        (!!this.mapFilter.Area2.Rai || this.mapFilter.Area2.Rai===0 ||
          !!this.mapFilter.Area2.Ngan || this.mapFilter.Area2.Ngan===0 ||
          !!this.mapFilter.Area2.SqWah || this.mapFilter.Area2.SqWah===0)) {
        let sqm1 = (this.mapFilter.Area1.Rai || 0) * 1600 +
                    (this.mapFilter.Area1.Ngan || 0) * 400 +
                    (this.mapFilter.Area1.SqWah || 0) * 4;
        let sqm2 = (this.mapFilter.Area2.Rai || 0) * 1600 +
                    (this.mapFilter.Area2.Ngan || 0) * 400 +
                    (this.mapFilter.Area2.SqWah || 0) * 4;
        if (sqm1<sqm2) {
          filter.area = 'area_sqm BETWEEN ' + sqm1 + ' AND ' + sqm2;
        } else if (sqm1>sqm2) {
          filter.area = 'area_sqm BETWEEN ' + sqm2 + ' AND ' + sqm1;
        } else {
          filter.area = 'area_sqm=' + sqm1;
        }
      }
    }
    if (isEmptyObject(filter)) {
      this.clearFilter();
    } else {
      this.$map.createFilter(filter);
    }
  }

  clearFilter() {
    for (let p in this.mapFilter) {
      if (p=='Source') {
        this.mapFilter[p] = 'GISagro';
      } else if (p=='Area1' || p=='Area2') {
        this.mapFilter[p] = {
          Rai: null,
          Ngan: null,
          SqWah: null
        }
      } else if (p!='Keyword') { //keep Keyword for search
        this.mapFilter[p] = null;
      }
    }
    this.$map.clearAoi();
    this.$map.clearFilter();
    this.$map.MapExtent = this.mapExtent;
  }

  clearOpener() {
    //called from created() in app's *.vue file
    let app = this.$store.getters.Page;
    if (window.opener && window.opener[app]) {
      delete window.opener[app];
    }
  }
  
  goToHome() {
    //this.$store.commit('notifyChange', {
    //  Page: 'home'
    //});
    let url;
    if (window.opener && window.opener.name=='GISagro') {
      url = ''; //so that page won't be reloaded
    } else {
      url = window.location.protocol + '//' + 
            window.location.hostname + 
            (window.location.port ? ':' + window.location.port : '');
    }
    let win = window.open(url, 'GISagro');
    //window.close();
    win.focus();
  };
}